import React, { useState, useMemo, useEffect } from 'react';
import { buildEngine } from '../../engine/Engine';
import ListingRow from '../../components/ListingRow';

const ResourceListingRow = props => {
  const {
    coveoOrganizationId,
    coveoAccessToken,
    coveoSearchHub,
    coveoPipeline,
    coveoSource,
    coveoSortOptions = '',
    coveoSortCaptions = '',
    coveoExpression = null,
    singleSelectFacetFields = '',
    singleSelectFacetTitles = '',
    multiSelectFacetFields = '',
    multiSelectFacetTitles = '',
    filterResultsLabel = 'Filter Results',
    locationCookieName,
    appliedLabel = 'applied'
  } = props;

  const engine = useMemo(() => {
    return buildEngine({
      organizationId: coveoOrganizationId,
      accessToken: coveoAccessToken,
      searchHub: coveoSearchHub,
      pipeline: coveoPipeline
    });
  }, []);

  return (
    <>
      <ListingRow
        coveoExpression={coveoExpression}
        coveoSortCaptions={coveoSortCaptions}
        coveoSortOptions={coveoSortOptions}
        coveoEngine={engine}
        coveoSource={coveoSource}
        isResource={true}
        singleSelectFields={singleSelectFacetFields}
        singleSelectTitles={singleSelectFacetTitles}
        multiSelectFields={multiSelectFacetFields}
        multiSelectTitles={multiSelectFacetTitles}
        filterResultsLabel={filterResultsLabel}
        locationCookieName={locationCookieName}
        appliedLabel={appliedLabel}
      />
    </>
  );
};

export default ResourceListingRow;
